import { Tree } from 'antd';
import { styled } from 'styled-components';

export const AntTree = styled(Tree)`
  background-color: inherit;
  color: var(--leftmenu-text-color);
  padding: 20px 10px;
  font-size: 16px;
  .ant-tree-node-content-wrapper-normal.ant-tree-node-selected {
    background: none !important;
  }
  .ant-tree-node-content-wrapper-close.ant-tree-node-selected {
    background: none !important;
  }
  .ant-tree-node-content-wrapper-open.ant-tree-node-selected {
    background: none !important;
  }
  &.tree-disabled .ant-tree-switcher {
    pointer-events: bounding-box !important;
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
